import { jsx, jsxs } from "react/jsx-runtime";
import { ApolloProvider } from "@apollo/client";
import { AmplitudeProvider } from "@crehana/analytics";
import { useApolloClient } from "@crehana/apollo-client";
import { AuthCentralizedProvider, AuthProvider } from "@crehana/auth";
import { envVars } from "@crehana/constants/env-vars";
import { I18nProvider } from "@crehana/i18n";
import { RBACProvider } from "@crehana/rbac/provider";
import { LANGUAGES } from "@crehana/ts-types";
import { Layout } from "@crehana/ui";
import { Channels } from "./Channels/index.js";
import { LazyCookiesBanner } from "./CookiesBanner/index.js";
import { RootErrorBoundaryWithSentry } from "./ErrorBoundaries/index.js";
import { OrganizationBrandingProvider } from "./organization-branding-provider/index.js";
import { TrackingProvider } from "./TrackingContext/index.js";
import { UIThemeProvider } from "./UITheme/index.js";
const CrehanaLayout = ({ children, initialApolloState, countryCode, pageKey, i18nProviderProps, renderCookiesBanner, isErrorPage, sentryInstance, amplitudeApiKey, organizationSlug })=>{
    const apolloClient = useApolloClient(initialApolloState, countryCode, pageKey);
    return /*#__PURE__*/ jsx(RootErrorBoundaryWithSentry, {
        sentryInstance: sentryInstance,
        children: /*#__PURE__*/ jsx(ApolloProvider, {
            client: apolloClient,
            children: /*#__PURE__*/ jsx(AuthProvider, {
                onLogout: ()=>{
                    window.location.href = `/logout/?next=${window.location.pathname}`;
                },
                meQueryOptions: {
                    skip: isErrorPage
                },
                children: /*#__PURE__*/ jsx(AuthCentralizedProvider, {
                    organizationSlug: organizationSlug,
                    children: /*#__PURE__*/ jsxs(OrganizationBrandingProvider, {
                        children: [
                            /*#__PURE__*/ jsx(Channels, {
                                countryCode: countryCode || ''
                            }),
                            /*#__PURE__*/ jsx(Layout, {
                                children: /*#__PURE__*/ jsx(TrackingProvider, {
                                    children: /*#__PURE__*/ jsx(AmplitudeProvider, {
                                        apiKey: amplitudeApiKey || envVars.AMPLITUDE_API_KEY || process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY,
                                        children: /*#__PURE__*/ jsx(UIThemeProvider, {
                                            children: /*#__PURE__*/ jsx(I18nProvider, {
                                                languageCode: LANGUAGES.ES,
                                                fallbackNs: [
                                                    'main-menu'
                                                ],
                                                ...i18nProviderProps,
                                                children: /*#__PURE__*/ jsxs("div", {
                                                    className: "tw-cds-root",
                                                    children: [
                                                        /*#__PURE__*/ jsx(RBACProvider, {
                                                            children: children
                                                        }),
                                                        renderCookiesBanner ? /*#__PURE__*/ jsx(LazyCookiesBanner, {}) : null
                                                    ]
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
export { CrehanaLayout };
